import { query } from './query'

export const blogListingPageQuery = {
  query,
  mocks: {
    defaultData: null,
  },
}
